export default "Go fast with the neom button!";